// Driver on-boarding WhatsApp messages.
import { formatPhoneForWhatsApp } from "./phoneFormat";

const APP_LOGIN_URL = (typeof window !== "undefined" ? window.location.origin : "") + "/login";

// 🎉 Welcome + Access Code message sent right after admin approval.
export function buildDriverWelcomeMessage({ name, phone, accessCode }) {
  return `🎉 *مرحباً ${name || "بك"}*

تم قبول طلب انضمامك إلى فريق *مراسم الزوار* 🌟

━━━━━━━━━━━━━━━━━━━━
🔐 *رمز الدخول الخاص بك:*
      *${accessCode}*
━━━━━━━━━━━━━━━━━━━━

📱 *خطوات الدخول:*
1️⃣ افتح تطبيق مراسم الزوار
2️⃣ اختر تبويب *سائق*
3️⃣ أدخل رقم جوالك: *${phone || ""}*
4️⃣ أدخل الرمز أعلاه

🔗 رابط الدخول:
${APP_LOGIN_URL}

⚠️ *تنبيه أمني:* هذا الرمز خاص بك — لا تشاركه مع أي شخص.

في حال فقدان الرمز، تواصل مع الإدارة لإعادة إصداره.

مرحباً بك في العائلة 🤝`;
}

// Build wa.me URL that opens WhatsApp with the welcome message.
export function buildDriverWelcomeUrl({ name, phone, whatsappPhone, accessCode }) {
  const to = formatPhoneForWhatsApp(whatsappPhone || phone);
  if (!to) return null;
  const msg = buildDriverWelcomeMessage({ name, phone, accessCode });
  return `https://wa.me/${to}?text=${encodeURIComponent(msg)}`;
}
